import { deserialize, serialize } from "cerialize";
import EntityAware from "../EntityAware";

export default class TUKDashboardBreakdown implements EntityAware {
    @serialize
    @deserialize
    public wilayah: string = "";

    @serialize
    @deserialize
    public bendahara_type: string = "";

    @serialize
    @deserialize
    public jenis_pemasukan_id: number = 0;

    @serialize
    @deserialize
    public jenis_pemasukan_name: string = "";

    @serialize
    @deserialize
    public saldo: number = 0;
}
